import { axiosInstance } from '../../api';
import axios from 'axios';
const BASE_PATH = '/candidate';
const BASE_PATH_PUBLIC = '/company_public';

//Get Presigned URL API Call
export let getCVPresignedURL = async (passedValues) => {
    try {
        let value = await axiosInstance.post(BASE_PATH_PUBLIC + '/get_presigned_urls_for_apply_job', {
            is_invited_candidate: passedValues.isInvitedCandidate,
            is_manually_uploaded: passedValues.isManuallyUploaded,
            pipeline_id: passedValues.pipelineID ? passedValues.pipelineID : null,
            candidate_id: passedValues.candidateID ? passedValues.candidateID : null,
            candidate_email: passedValues.email ? passedValues.email : null,
            candidate_image_type: passedValues.candidateImageType ? passedValues.candidateImageType : null
        })
        return value;
    } catch (error) {
        return error
    }
}



//Upload CV API Call
export let uploadCV = async (preSignedUrl, getfile) => {
    try {

        let formData = new FormData();
        formData.append('file', getfile);
        let value = await axios.put(preSignedUrl, formData, {
            headers: {
                'Content-Type': getfile.type
            }
        })
        return value;
    } catch (error) {
        return error
    }
}

//Upload Cover Letter API Call
export let uploadCoverLetter = async (preSignedUrl, getfile) => {
    try {

        let formData = new FormData();
        formData.append('file', getfile);
        let value = await axios.put(preSignedUrl, formData, {
            headers: {
                'Content-Type': getfile.type
            }
        })
        return value;
    } catch (error) {
        return error
    }
}

//Upload CV API Call
export let uploadImage = async (preSignedUrl, getfile) => {
    try {
        let value = await axios.put(preSignedUrl, getfile, {
            headers: {
                'Content-Type': getfile.type
            }
        })
        return value;
    } catch (error) {
        return error
    }
}


//upload Candidate Details API Call
export let signupCandidate = async (status, cadidateID, firstName, lastName, countryCode, pNumber, imageType, foundBy) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/signup_candidate', {
            is_invited_candidate: status,
            candidate_id: cadidateID,
            candidate_first_name: firstName,
            candidate_last_name: lastName,
            mobile_country_code: countryCode,
            mobile_number: pNumber,
            candidate_image_type: imageType,
            known_about_vacancy_via: foundBy
        })
        return value;
    } catch (error) {
        return error
    }
}


//upload Candidate note Details API Call
export let addSpecialNote = async (cadidateID, Note) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/add_special_note', {
            candidate_id: cadidateID,
            note: Note,
        })
        return value;
    } catch (error) {
        return error
    }
}